import script from "./DadosEmpresaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DadosEmpresaPage.vue?vue&type=script&setup=true&lang=js"

import "./DadosEmpresaPage.vue?vue&type=style&index=0&id=49f1ed68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f1ed68"]])

export default __exports__